import { HttpParams } from '@angular/common/http';
import { FormTemplateType } from '@nrwl/rx-models';

/** Which template types a forms request asks for: every type, personalized plans only, or forms only. */
export type FormTypeQuery = 'all' | 'plan' | 'form';

export interface FormRequestOptions {
  formType?: FormTypeQuery;
}

/**
 * The `form_type` value per query. Since backend RXP-1277 the forms routes take comma-separated
 * template type ids and reject any other value, and no value means every type, so `all` sends
 * nothing.
 */
const FORM_TYPE_VALUES: Record<FormTypeQuery, string | null> = {
  all: null,
  plan: String(FormTemplateType.PersonalizedPlan),
  form: [FormTemplateType.Pdf, FormTemplateType.Fillable].join(','),
};

/** Adds the `form_type` filter of the forms routes for the requested query, if any. */
export function withFormType(params: HttpParams, options: FormRequestOptions = {}): HttpParams {
  const value = options.formType ? FORM_TYPE_VALUES[options.formType] : null;

  return value ? params.set('form_type', value) : params;
}
